<template>
	<page>
		<module>
			<view-list
				ref="view"
				work-type="41"
				selector
			>
				<template #search>
					<m-search ref="search">
						<m-search-item label="场次">
							<c-input name="auction_batch_no"></c-input>
						</m-search-item>
						<m-search-item label="报告时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<!-- 金额列红色展示 -->
				<template #deal_amount="{data}">
					<span style="color: #e53e3e;">{{formatPrice(data.deal_amount)}}</span>
				</template>
				<template #gross_profit="{data}">
					<span style="color: #e53e3e;">{{formatPrice(data.gross_profit)}}</span>
				</template>

				<c-table-column
					type="button"
					label="操作"
					width="160"
					button-limit="6"
				>
					<template #default="{data}">
						<c-table-button icon="tf-detail" @click="viewDetail(data)">报告详情</c-table-button>
						<c-table-button icon="tf-detail" @click="viewDealDetail(data)">成交明细</c-table-button>
					</template>
				</c-table-column>
			</view-list>

			<!-- 统计报告详情 -->
			<auction-stat-report-detail ref="detail"></auction-stat-report-detail>
			<!-- 成交明细 -->
			<auction-deal-detail ref="dealDetail"></auction-deal-detail>
		</module>
	</page>
</template>

<script>
	import AuctionStatReportDetail from './auction_stat_report_detail';
	import AuctionDealDetail from './auction_deal_detail';

	export default {
		components: {
			AuctionStatReportDetail,
			AuctionDealDetail
		},

		methods: {
			/*********查看统计报告详情**********/
			viewDetail(data) {
				this.$refs.detail.open({
					id: data.id
				});
			},

			/*********查看成交明细**********/
			viewDealDetail(data) {
				this.$refs.dealDetail.open({
					auction_batch_no: data.auction_batch_no
				});
			},

			/*********格式化价格**********/
			formatPrice(price) {
				if (price === null || price === undefined || price === '') return '-';
				return '¥' + parseFloat(price).toFixed(2);
			}
		}
	}
</script>
